'use strict';
/* tslint:disable */
/* eslint-disable */
/**
 * Attachments API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter =
    (this && this.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done
                    ? resolve(result.value)
                    : adopt(result.value).then(fulfilled, rejected);
            }
            step(
                (generator = generator.apply(thisArg, _arguments || [])).next()
            );
        });
    };
Object.defineProperty(exports, '__esModule', { value: true });
exports.AttachmentApi = void 0;
const runtime = require('../runtime');
const models_1 = require('../models');
/**
 *
 */
class AttachmentApi extends runtime.BaseAPI {
    /**
     * Add a new Attachment
     */
    addAttachmentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (
                requestParameters.body === null ||
                requestParameters.body === undefined
            ) {
                throw new runtime.RequiredError(
                    'body',
                    'Required parameter requestParameters.body was null or undefined when calling addAttachment.'
                );
            }
            const queryParameters = {};
            if (requestParameters.allOrNone !== undefined) {
                queryParameters['allOrNone'] = requestParameters.allOrNone;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (
                this.configuration &&
                (this.configuration.username !== undefined ||
                    this.configuration.password !== undefined)
            ) {
                headerParameters['Authorization'] =
                    'Basic ' +
                    btoa(
                        this.configuration.username +
                            ':' +
                            this.configuration.password
                    );
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters['Authorization'] =
                    yield this.configuration.accessToken('ciam', [
                        'crm:sf-api',
                    ]);
            }
            const response = yield this.request(
                {
                    path: `/`,
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: requestParameters.body.map(
                        models_1.AttachmentDTOToJSON
                    ),
                },
                initOverrides
            );
            return new runtime.JSONApiResponse(response, (jsonValue) =>
                jsonValue.map(models_1.AttachmentResponseFromJSON)
            );
        });
    }
    /**
     * Add a new Attachment
     */
    addAttachment(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.addAttachmentRaw(
                requestParameters,
                initOverrides
            );
            return yield response.value();
        });
    }
    /**
     * Returns a single Attachment
     * Find Attachment by ID
     */
    getAttachmentByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (
                requestParameters.id === null ||
                requestParameters.id === undefined
            ) {
                throw new runtime.RequiredError(
                    'id',
                    'Required parameter requestParameters.id was null or undefined when calling getAttachmentById.'
                );
            }
            const queryParameters = {};
            const headerParameters = {};
            if (
                this.configuration &&
                (this.configuration.username !== undefined ||
                    this.configuration.password !== undefined)
            ) {
                headerParameters['Authorization'] =
                    'Basic ' +
                    btoa(
                        this.configuration.username +
                            ':' +
                            this.configuration.password
                    );
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters['Authorization'] =
                    yield this.configuration.accessToken('ciam', [
                        'crm:sf-api',
                    ]);
            }
            const response = yield this.request(
                {
                    path: `/{id}`.replace(
                        `{${'id'}}`,
                        encodeURIComponent(String(requestParameters.id))
                    ),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
            return new runtime.JSONApiResponse(response, (jsonValue) =>
                (0, models_1.AttachmentResponseFromJSON)(jsonValue)
            );
        });
    }
    /**
     * Returns a single Attachment
     * Find Attachment by ID
     */
    getAttachmentById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAttachmentByIdRaw(
                requestParameters,
                initOverrides
            );
            return yield response.value();
        });
    }
}
exports.AttachmentApi = AttachmentApi;
